import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { appUtil } from 'clink-ui-x/utils';
import * as moment from 'moment';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import { CompatibleDate, DisabledTimeFn, NzDatePickerSizeType } from 'ng-zorro-antd/date-picker';
@Component({
    selector: 'clink-customize-date-time-picker',
    templateUrl: './customize-date-time-picker.component.html',
    styleUrls: ['./customize-date-time-picker.component.less'],
})
export class CustomizeDateTimePickerComponent implements OnChanges {
    @Input() initialDate = ''; // 初始日期值
    @Input() disabled = false; // 当前组件是否禁用
    @Input() placeHolder = '请选择'; // 提示文字
    @Input() showTime = true; // 是否展示时间选择器
    @Input() showFormat = 'yyyy/MM/dd HH:mm:ss'; // 展示日期格式
    @Input() updateFormat = 'YYYY/MM/DD HH:mm:ss'; // 更新日期数据的格式
    @Input() disabledStartTime?: Date; // 不可选择时间
    @Input() nzSize: NzDatePickerSizeType = 'small'; // 组件大小
    @Input() isError = false; // 当前对应控件是否有错误
    @Input() errorExpression = '必填项！'; // 错误提示语
    @Output() updateDate: EventEmitter<any> = new EventEmitter();

    showDateValue: CompatibleDate | null = null; // 展示日期

    ngOnChanges(changes: SimpleChanges): void {
        // 初始时间变更
        if (changes.initialDate) {
            if (changes.initialDate.currentValue) {
                this.showDateValue = appUtil.handleTimeDateValue(changes.initialDate.currentValue);
            } else {
                this.showDateValue = null;
            }
        }
    }

    /**
     * 更新日期时间值
     *
     * @memberof CustomizeDateTimePickerComponent
     */
    updateDateValue(event: any): void {
        if (event) {
            // Date 对象转换为时间戳
            const newDateValue = event.valueOf();
            const newValue = moment(newDateValue).format(this.updateFormat);
            this.updateDate.emit(newValue);
        } else {
            // 无值返回 null
            this.updateDate.emit(null);
        }
    }

    /**
     * 设置不可选日期
     *
     * @memberof CustomizeDateTimePickerComponent
     */
    disabledSelectedDate = (selectedValue: Date): boolean => {
        if (!selectedValue || !this.disabledStartTime) {
            return false;
        }

        // 禁用日期之前的日期
        return differenceInCalendarDays(selectedValue, this.disabledStartTime) < 0;
    };

    /**
     * 设置不可选时间
     *
     * @type {DisabledTimeFn}
     * @memberof CustomizeDateTimePickerComponent
     */
    disabledSelectedDateTime: DisabledTimeFn = (currentValue: Date) => {
        if (this.disabledStartTime && differenceInCalendarDays(currentValue, this.disabledStartTime) <= 0) {
            // 禁用日期之前或当天
            const disabledHour = this.disabledStartTime.getHours();
            const disabledMinute = this.disabledStartTime.getMinutes();
            const disabledSecond = this.disabledStartTime.getSeconds();
            return {
                nzDisabledHours: () => this.getRangeArr(0, disabledHour),
                nzDisabledMinutes: (hour: number) => {
                    if (hour === disabledHour) {
                        return this.getRangeArr(0, disabledMinute);
                    } else {
                        return [];
                    }
                },
                nzDisabledSeconds: (hour: number, minute: number) => {
                    if (hour === disabledHour && minute === disabledMinute) {
                        return this.getRangeArr(0, disabledSecond);
                    } else {
                        return [];
                    }
                },
            };
        }
        return {
            nzDisabledHours: () => [],
            nzDisabledMinutes: () => [],
            nzDisabledSeconds: () => [],
        };
    };

    /**
     * 生成禁用时间区间数组
     *
     * @param {number} start
     * @param {number} end
     * @returns {number[]}
     * @memberof CustomizeDateTimePickerComponent
     */
    getRangeArr(start: number, end: number): number[] {
        const result: number[] = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    }
}
